// Components
import MenuEntry from './MenuEntry';

// Types
import { HeaderType } from '../HeaderType';

// Styles
import styles from './Menu.module.css';

interface MenuProps {
  menu?: HeaderType['menus'];
}

function Menu({ menu = null }: MenuProps) {
  return (
    <div className={styles.menu}>
      {menu && menu.length > 0
        ? menu.map((entry) => <MenuEntry key={entry.label} entry={entry} forceDropdownOpen={false} />)
        : null}
    </div>
  );
}

export default Menu;
